import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from './Layouts/Header';
import Footer from './Layouts/Footer';
import { fetchFooterData, sendContact } from '../utils/apiService';

const Contact = () => {
    const [contactData, setContactData] = useState(null);
    const [formData, setFormData] = useState({
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        message: ''
    });
    const [status, setStatus] = useState({ type: '', message: '' });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const getContactData = async () => {
            const result = await fetchFooterData();
            if (result && result.status) {
                setContactData(result.data);
            }
        };
        getContactData();
    }, []);

    useLayoutEffect(() => {
        const timer = setTimeout(() => {
            if (window.animationText) window.animationText();
            if (window.scrollingEffect) window.scrollingEffect();
            if (window.animateImgItem) window.animateImgItem();

            if (window.ScrollTrigger) window.ScrollTrigger.refresh();
        }, 800);

        return () => {
            clearTimeout(timer);
            if (window.revertAnimations) window.revertAnimations();
            if (window.revertHeadline) window.revertHeadline();
        };
    }, [contactData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setStatus({ type: '', message: '' });

        const result = await sendContact(formData);

        if (result && result.status) {
            setStatus({ type: 'success', message: result.message || 'Thank you for contacting us.' });
            setFormData({
                firstname: '',
                lastname: '',
                email: '',
                phone: '',
                message: ''
            });
        } else {
            setStatus({ type: 'error', message: result.message || 'Something went wrong. Please try again.' });
        }
        setLoading(false);
    };

    return (
        <div className="wrapper position-relative">
            <Header />

            <div className="page-title">
                <div className="tf-container">
                    <div className="page-title-content text-center">
                        <h1 className="title" dangerouslySetInnerHTML={{ __html: '<span class="split-text effect-right">Contact Us</span>' }} />
                        <div className="breadkcum">
                            <Link to="/" className="link-breadkcum body-2 fw-7">
                                <span className="split-text effect-right" dangerouslySetInnerHTML={{ __html: 'Home' }} />
                            </Link>
                            <span className="dot"></span>
                            <span className="page-breadkcum body-2 fw-7">
                                <span className="split-text effect-right" style={{ color: 'var(--primary)' }} dangerouslySetInnerHTML={{ __html: 'Contact Us' }} />
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="main-content">
                <section className="section-contact p-contact tf-spacing-2">
                    <div className="tf-container">
                        <div className="section-contact-inner flex justify-content-between flex-wrap">

                            <div className="left">
                                <div className="heading-section mb-30">
                                    <div
                                        className="sub-title body-2 fw-7 mb-17 title-animation"
                                        dangerouslySetInnerHTML={{ __html: 'Get In Touch' }}
                                    />
                                    <h2
                                        className="title fw-6 mb-10 title-animation"
                                        dangerouslySetInnerHTML={{ __html: 'Let\'s Talk For <span class="fw-3">Next Projects</span>' }}
                                    />
                                </div>
                                <div className="contact-list mb-30">
                                    <div
                                        className="contact-item location-item tf-animate-3"
                                        dangerouslySetInnerHTML={{
                                            __html: `<i class="icon-location-dot"></i><a href="#" class="lh-30">${contactData?.address || 'Loading...'}</a>`
                                        }}
                                    />
                                    <div
                                        className="contact-item tf-animate-3"
                                        dangerouslySetInnerHTML={{
                                            __html: `<i class="icon-email"></i><a href="mailto:${contactData?.email || ''}" class="lh-30">${contactData?.email || 'Loading...'}</a>`
                                        }}
                                    />
                                    <div
                                        className="contact-item tf-animate-3"
                                        dangerouslySetInnerHTML={{
                                            __html: `<i class="icon-phone"></i><a href="tel:${contactData?.phone || ''}" class="lh-30">${contactData?.phone || 'Loading...'}</a>`
                                        }}
                                    />
                                </div>
                                <div className="contact-social">
                                    <div className="title body-2 fw-7 tf-animate-3">Follow Me</div>
                                    <ul className="post-social style-radius-50 style-bg-white g-10 tf-animate-3">
                                        {contactData?.fb_link && (
                                            <li><a href={contactData.fb_link} className="icon-social" target="_blank" rel="noreferrer"><i className="icon-fb"></i></a></li>
                                        )}
                                        {contactData?.instagram_link && (
                                            <li><a href={contactData.instagram_link} className="icon-social" target="_blank" rel="noreferrer"><i className="icon-instagram"></i></a></li>
                                        )}
                                        {contactData?.x_link && (
                                            <li><a href={contactData.x_link} className="icon-social" target="_blank" rel="noreferrer"><i className="icon-X"></i></a></li>
                                        )}
                                        {contactData?.tiktok_link && (
                                            <li><a href={contactData.tiktok_link} className="icon-social" target="_blank" rel="noreferrer"><i className="fa-brands fa-tiktok"></i></a></li>
                                        )}
                                    </ul>
                                </div>
                            </div>

                            <div className="right">
                                <form onSubmit={handleSubmit} id="contactform" className="form-contact-us style-bg-dark-2 px-md-15">
                                    {status.message && (
                                        <div className={`flat-alert mb-20 ${status.type === 'success' ? 'msg-success' : 'msg-error'}`}>
                                            {status.message}
                                        </div>
                                    )}
                                    <div className="cols mb-37 g-30">
                                        <fieldset className="item">
                                            <fieldset className="position-relative">
                                                <i className="icon-user"></i>
                                                <input
                                                    type="text"
                                                    name="firstname"
                                                    placeholder="First Name"
                                                    value={formData.firstname}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </fieldset>
                                        </fieldset>

                                        <fieldset className="item">
                                            <fieldset className="position-relative">
                                                <i className="icon-user"></i>
                                                <input
                                                    type="text"
                                                    name="lastname"
                                                    placeholder="Last Name"
                                                    value={formData.lastname}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </fieldset>
                                        </fieldset>
                                    </div>
                                    <div className="cols mb-37 g-30">
                                        <fieldset className="item">
                                            <fieldset className="position-relative">
                                                <i className="icon-email"></i>
                                                <input
                                                    type="email"
                                                    name="email"
                                                    placeholder="Email Address"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </fieldset>
                                        </fieldset>

                                        <fieldset className="item">
                                            <fieldset className="position-relative">
                                                <i className="icon-phone"></i>
                                                <input
                                                    type="text"
                                                    name="phone"
                                                    placeholder="Phone Number"
                                                    value={formData.phone}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </fieldset>
                                        </fieldset>
                                    </div>

                                    <fieldset className="mb-40">
                                        <textarea
                                            name="message"
                                            placeholder="Message"
                                            value={formData.message}
                                            onChange={handleChange}
                                            required
                                        ></textarea>
                                    </fieldset>

                                    <button type="submit" className="tf-btn" disabled={loading}>
                                        <span>{loading ? 'Sending...' : 'Send Us Message'}</span>
                                        {!loading && <i className="icon-arrow-right"></i>}
                                    </button>

                                </form>
                            </div>

                        </div>
                    </div>
                </section>
            </div>
            <Footer />
        </div>
    );
};

export default Contact;
